import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_SIDEBAR_COMPANY_FRAGMENT } from '../../components/NarrativeSidebar/narrativeSidebarFragment';
import { NARRATIVE_HEADER_COMPANY_FRAGMENT } from '../../components/PublicNarrativeHeader/narrativeCompanyFragment';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import { VALUATION_FRAGMENT } from '../valuationFragment';
import { NARRATIVE_OWNER_FRAGMENT } from '@/components/NarrativeAuthor/NarrativeAuthor';

const QUERY = gql(
  `
  query getNarrativeValuationCompany($companyId: String!) {
    Company(id: $companyId) {
      myNarrative {
        id
        userHoldsPosition
        owner {
          ...NarrativeOwnerFields
        }
        draftUpdate {
          id
          title
          contentHtml
          valuation {
            ...ValuationFields
          }
          publishedAt
          willLockAt
        }
        latestPublishedUpdate {
          id
          title
          contentHtml
          lockedAt
          willLockAt
          publishedAt
          valuation {
            ...ValuationFields
          }
        }
      }
      ...NarrativeSidebarCompanyFields
      ...NarrativeHeaderCompanyFields
    }
  }
`,
  [
    NARRATIVE_SIDEBAR_COMPANY_FRAGMENT,
    NARRATIVE_HEADER_COMPANY_FRAGMENT,
    VALUATION_FRAGMENT,
    NARRATIVE_OWNER_FRAGMENT,
  ]
);

export const useNarrativeValuationCompany = makeGqlQuery(QUERY, {
  staleTime: 3600000,
  tags: ['narrative', 'narrative-valuation-company'],
});

export type NarrativeValuationCompany = ResolvedQueryData<
  typeof useNarrativeValuationCompany
>['Company'];
